import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DownloadDoneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"download_done"}/>
}
